/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_SettleInputs */

const en_case_detail_settle = /** @type {(inputs: Case_Detail_SettleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settle`)
};

const pt_br2_case_detail_settle = /** @type {(inputs: Case_Detail_SettleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encerrar`)
};

/**
* | output |
* | --- |
* | "Settle" |
*
* @param {Case_Detail_SettleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_settle = /** @type {((inputs?: Case_Detail_SettleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_SettleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_settle(inputs)
	return pt_br2_case_detail_settle(inputs)
});